._1b1ucl70 {
  position: relative;
  width: var(--width);
  max-width: var(--max-width);
  margin: var(--margin);
}
._5cga7e0 > ._1b1ucl70 {
  padding-left: 30px;
  padding-right: 30px;
}
._8lfidn0 > ._1b1ucl70 {
  width: calc(100% - var(--margin-left) - var(--margin-right));
  max-width: calc(100% - var(--margin-left) - var(--margin-right));
}
._1b1ucl71 {
  -webkit-font-smoothing: auto;
  font-family: monospace;
}
._1b1ucl72 {
  margin: 0;
  line-height: normal;
  overflow-x: auto;
  padding: 1.25em 1.5em;
  white-space: pre;
  word-wrap: normal;
  background-color: var(--background-button);
  box-shadow: var(--box-shadow);
  border-radius: var(--border-radius);
  -webkit-font-smoothing: auto;
  font-family: monospace;
}